import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=5b6baacc&scoped=true"
import script from "./TableContent.vue?vue&type=script&lang=ts"
export * from "./TableContent.vue?vue&type=script&lang=ts"
import style0 from "./TableContent.vue?vue&type=style&index=0&id=5b6baacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6baacc",
  null
  
)

export default component.exports